import { createGlobalStyle } from 'styled-components'

export const CoreUIOverrides = createGlobalStyle`
  .sidebar {
    background-size: cover;
    background-position: center;
  }

  .sidebar-brand {
    background-color: #fff0 !important;
  }

  .sidebar:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 5rem;
  }

  .nav-link {
    font-family: Montserrat;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #7b7b7d !important;
    padding: 0.5rem 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    :hover {
      color: #2c2c2d;
    }
  }

  .nav-link.active {
    color: #2c2c2d !important;
  }

  @media (max-width: 991px) {
    .header-avatar {
      display: none;
    }

    .header__dropdown {
      margin: 0 !important;
    }

    .dropdown__wrapper {
      display: none !important;
    }

    .header-notification {
      width: 25% !important;
    }
  }

  .header__dropdown {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    gap: 16px;
    min-width: 15%;
    color: black;
  }

  .nav-item {
    padding-left: 10px;
    color: #7b7b7d !important;
    transition: all 0.3s ease;
  }

  .header-notification {
    padding: 12px;
    :hover {
      background: #f5f5f5;
    }
  }
`
